import { ArrowUpRight, Heart } from "lucide-react";
import { SOCIALS } from "../data/site";
import { Reveal } from "./motion";

const channels = [
  { label: "Etsy", note: "Shop the full collection", href: SOCIALS.etsy, id: "footer-etsy-link" },
  { label: "Travel", note: "Personalized travel booking", href: "https://edrinaafre.inteletravel.com", id: "footer-travel-link" },
  { label: "YouTube", note: "Studio films & drops", href: SOCIALS.youtube, id: "footer-youtube-link" },
  { label: "TikTok", note: "Behind the lettering", href: SOCIALS.tiktok, id: "footer-tiktok-link" },
];

export const Footer = () => (
  <footer data-testid="footer-section" className="bg-navy text-cream">
    <div className="mx-auto max-w-[1600px] px-6 pt-28 pb-12 md:px-12 md:pt-40">
      <Reveal>
        <p className="text-xs font-medium uppercase tracking-[0.3em] text-cream/50">Say hello — find us here</p>
        <h2 className="mt-8 font-caveat text-[14vw] font-semibold leading-[0.9] text-cream md:text-[9vw] lg:text-[8vw]">
          Make today amazing
          <Heart className="mb-4 ml-3 inline-block h-[5vw] w-[5vw] fill-mustard text-mustard" />
        </h2>
      </Reveal>

      <div className="mt-20 md:mt-28">
        {channels.map((c, i) => (
          <Reveal key={c.label} delay={i * 0.08}>
            <a
              href={c.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={c.id}
              className="group flex items-center justify-between gap-6 border-t border-cream/15 py-8 transition-all duration-500 last:border-b hover:pl-4 md:py-10"
            >
              <div className="flex flex-wrap items-baseline gap-x-6 gap-y-1">
                <span className="font-playfair text-4xl tracking-tight md:text-6xl">{c.label}</span>
                <span className="text-[11px] uppercase tracking-[0.25em] text-cream/50">{c.note}</span>
              </div>
              <ArrowUpRight className="h-8 w-8 shrink-0 text-cream/40 transition-all duration-500 group-hover:translate-x-2 group-hover:-translate-y-2 group-hover:text-mustard md:h-12 md:w-12" />
            </a>
          </Reveal>
        ))}
      </div>

      <div className="mt-20 flex flex-wrap items-center justify-between gap-6 border-t border-cream/10 pt-8 text-[11px] uppercase tracking-[0.2em] text-cream/40">
        <p>© 2026 Dream Freely Studios</p>
        <p className="font-playfair normal-case italic tracking-normal text-cream/60">
          Good things are allowed to happen.
        </p>
        <p>Orders fulfilled via Etsy</p>
      </div>
    </div>
  </footer>
);
